import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api } from "../lib/api";

export const useCompetitions = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/competitions").then((r) => setList(r.data)).catch(() => {});
  }, []);
  return list;
};

export const CompetitionSelect = ({ value, onChange, testId }) => {
  const comps = useCompetitions();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="h-11 bg-[#121824] border-[#26334D]">
        <SelectValue placeholder="Competizione" />
      </SelectTrigger>
      <SelectContent className="bg-[#121824] border-[#26334D]">
        {comps.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid={`${testId}-option-${c.code}`}>{c.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
